import type { SVGProps } from "react";

const LiveIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 21"
    fill="none"
    {...props}
  >
    <path
      d="M10.0004 10.0003V10.0086M12.357 7.64363C12.9819 8.26873 13.333 9.11642 13.333 10.0003C13.333 10.8842 12.9819 11.7319 12.357 12.357M14.7145 5.28613C15.3336 5.90519 15.8247 6.64014 16.1598 7.449C16.4948 8.25786 16.6673 9.12479 16.6673 10.0003C16.6673 10.8758 16.4948 11.7427 16.1598 12.5516C15.8247 13.3605 15.3336 14.0954 14.7145 14.7145M7.64036 12.357C7.01545 11.7319 6.6644 10.8842 6.6644 10.0003C6.6644 9.11642 7.01545 8.26873 7.64036 7.64363M5.28119 14.7145C4.6621 14.0954 4.171 13.3605 3.83595 12.5516C3.5009 11.7427 3.32845 10.8758 3.32845 10.0003C3.32845 9.12479 3.5009 8.25786 3.83595 7.449C4.171 6.64014 4.6621 5.90519 5.28119 5.28613"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LiveIcon;